import { styled, css } from "styled-components";
import { EditorContentWrapper } from "@admin/config/overrides/fieldTypes/MarkdownEditor/children/EditorContent/styles";

export const TextEditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.default[200]};
  border-radius: 4px;
  overflow: clip;
`;
